import { c as _c } from "react/compiler-runtime";
import { FunnelTriggerDataInterface } from 'modules/funnels/funnel/components/funnel-rules/utils/fill-trigger-with-funnel-data';
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel';
import { useFunnelStepsList } from 'modules/funnels/funnel/hooks/use-funnel-steps-list';
import { useWebinarRegistrationSettings } from 'modules/funnels/funnel/hooks/use-webinar-registration-settings';
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import { FunnelStepTypeEnum } from 'shared/enums/funnel-step-type-enum';
export const useFunnelStepRuleData = (funnelId, funnelStepId) => {
  const $ = _c(12);
  const {
    funnel
  } = useFunnel(funnelId);
  const {
    funnelStepsList
  } = useFunnelStepsList(funnelId);
  let t0;
  if ($[0] !== funnelStepId || $[1] !== funnelStepsList) {
    t0 = funnelStepsList?.find(step => step.id === funnelStepId);
    $[0] = funnelStepId;
    $[1] = funnelStepsList;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const funnelStep = t0;
  const t1 = funnelStep?.type === FunnelStepTypeEnum.WebinarRegistration;
  let t2;
  if ($[3] !== t1) {
    t2 = {
      shouldFetch: t1
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    webinarRegistrationSettings
  } = useWebinarRegistrationSettings(funnelStepId, t2);
  let t3;
  if ($[5] !== funnel || $[6] !== funnelId || $[7] !== funnelStep || $[8] !== webinarRegistrationSettings?.webinar) {
    t3 = funnel && funnelStep && funnelStep.page ? {
      funnelId,
      funnelStepId: funnelStep.id,
      funnelStepName: funnelStep.name,
      pageContentId: funnelStep.page.id,
      funnelName: funnel.name,
      webinarId: webinarRegistrationSettings?.webinar.id
    } : undefined;
    $[5] = funnel;
    $[6] = funnelId;
    $[7] = funnelStep;
    $[8] = webinarRegistrationSettings?.webinar;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const funnelTriggerData = t3;
  let t4;
  if ($[10] !== funnelTriggerData) {
    t4 = {
      funnelTriggerData
    };
    $[10] = funnelTriggerData;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};